// extracted by mini-css-extract-plugin
export default {"projects-grid":"Projects_projects-grid__eaLQA","project-card":"Projects_project-card__PeaVV","title":"Projects_title__DVb8C"};